import { FirebaseService } from './firebase.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as copy from 'copy-to-clipboard';
import { Browser } from '@capacitor/browser';

@Injectable({
    providedIn: 'root'
})
export class BrowserService {

    constructor(public fire: FirebaseService, public http: HttpClient) { }

    async openInBrowser(url: string) {
        await Browser.open({ url });
    }

    copyLink(link: string) {
        copy(link);
        this.fire.showToast('Invite Link Copied!');
    }
}
